import React, {useState} from "react";
import Card from "../Card/Card";

const CardsStatusSection = () => {
  const data = [
    {
      status: "In Progress",
      access: "Tier 1 & 2",
      participants: "266",
      block: "BSC",
      amount: "18,000",
      percent: `${(18000 / 50000) * 100}%`,
    },
    {
      status: "Upcoming",
      access: "Tier 1 & 2",
      participants: "---",
      block: "BSC",
      amount: "0",
      percent: `${(0 / 50000) * 100}%`,
    },
  ];
  const handleRaise = () => {
    window.location.href= "/raise";
  }
  return (
    <div>
      <div className="container mt-[80px] md:mt-[159px]">
        <div className="max-w-[847px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[47px]">
            {data.map((single) => (
              <Card key={single.status} {...single}></Card>
            ))}
          </div>
          <div className="mt-[44px] flex justify-center">
            <button onClick={handleRaise} className=" w-[173px] h-10 border rounded-[20px] border-solid border-[#01CC8E]">
              <span className="text-res-xs font-bold">View Raises</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardsStatusSection;
